import { useState, useEffect } from 'react';
import _ from 'lodash';

const getDeviceConfig = (width) => {
  if (width < 640) {
    return 2;
  }
  if (width >= 640 && width < 768) {
    return 3;
  }
  if (width >= 768 && width < 1024) {
    return 4;
  }
  if (width >= 1024) {
    return 7;
  }
};

const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = useState(() =>
    getDeviceConfig(window.innerWidth)
  );

  useEffect(() => {
    const calcInnerWidth = _.throttle(() => {
      setBrkPnt(getDeviceConfig(window.innerWidth));
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return brkPnt;
};
export default useBreakpoint;
